// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"9fb57eb3","703":"3225383e","787":"e8fcdff7"}[chunkId] + ".chunk.js";
};